export default [
    {
        path: "products",
        name: "RedemptionProducts",
        component: () =>
            import(
                /* webpackChunkName: "RedemptionProducts" */ "@/views/loyaltyPanel/redemptions/tabs/Products.vue"
            )
    },

    {
        path: "vouchers",
        name: "RedemptionVouchers",
        component: () =>
            import(
                /* webpackChunkName: "RedemptionVouchers" */ "@/views/loyaltyPanel/redemptions/tabs/Vouchers.vue"
            )
    },

    {
        path: "all",
        name: "RedemptionAll",
        component: () =>
            import(
                /* webpackChunkName: "RedemptionGifts" */ "@/views/loyaltyPanel/redemptions/tabs/All.vue"
            )
    }
];
